// src/stone/illustrations/StonjiPixIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPixIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h80v80H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          stroke: "#fff",
          d: "M40 22.448v9.93M62 35.618v12M47 35.618v12M62.5 52.24v12.413M47 54.722l18.5-.104M40 52.24v12.413M50 52.24v12.413M36 38.618h13M54 44.618h11M15 39.826h17.5M29.857 29.733H18V18h11.857zM29.857 61.653H18V49.92h11.857z"
        }
      ),
      /* @__PURE__ */ jsx("path", { stroke: "#00A868", d: "M62 29.733H50.143V18H62z" })
    ]
  }
);
var StonjiPixIllustration_default = StonjiPixIllustration;

export {
  StonjiPixIllustration_default
};
